module.exports = __webpack_public_path__ + "static/media/ineditGlass.aa662a04.jpg";